import { ApiError } from '@gorila-shared-ui/components';
import { AppPermission } from '../types/appPermission';
import { Workspace } from '../types/workspace';
import { downloadRequest, externalDownloadRequest, externalFileRequest, fileRequest, getRequest } from './api';
import { clientWorkspacesUrl } from './urls/clientUrls';
import { permissionsUrl } from './urls/permissionUrls';

export const getAppPermissions = async (): Promise<{ appPermissions?: AppPermission; error?: ApiError }> => {
  const response = await getRequest(permissionsUrl);

  return {
    appPermissions: response?.data.permissions,
    error: response?.error,
  };
};

export const getWorkspaces = async (clientId: string): Promise<{ workspaces?: Workspace[]; error?: ApiError }> => {
  const response = await getRequest(clientWorkspacesUrl(clientId));
  return {
    workspaces: response?.data?.subClients,
    error: response?.error,
  };
};

export const getS3FileUrlByKey = async (
  key: string,
  fromExternal: boolean = false,
  doesNotExpire: boolean = false,
): Promise<{ url?: string; error?: ApiError }> => {
  const response = await (fromExternal
    ? externalFileRequest(key, undefined, undefined, doesNotExpire)
    : fileRequest(key, doesNotExpire));
  return {
    url: response?.data?.url,
    error: response?.error,
  };
};

export const getS3DownloadUrlByKey = async (
  key: string,
  fromExternal: boolean = false,
): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await (fromExternal ? externalDownloadRequest(key) : downloadRequest(key));
  return {
    file: response?.data?.file,
    error: response?.error,
  };
};
